import { Trans } from "@lingui/react/macro";
import {
  activityRequirementSchema,
  type IActivityRequirement,
} from "@medoma/models/activityRequirements";
import { CompetenceChip } from "./CompetenceChip";
import type { IActivityRequirementStatus } from "@medoma/models/activities";
import { getBackground, getBorder } from "./chipUtils";
import Chip from "@medoma/components/Chip/Chip";
import CustomProperties from "@medoma/components/CustomProperties/CustomProperties";
import styles from "./RequirementChip.module.scss";

export const RequirementChip = ({
  requirement,
  state,
  size,
}: {
  requirement: IActivityRequirement;
  state: IActivityRequirementStatus;
  content?: string;
  onRemove?: () => void;
} & Pick<Parameters<typeof Chip>[0], "size">) => {
  if (requirement === activityRequirementSchema.enum.DoubleStaffing) {
    return (
      <CustomProperties className={styles["double-staffing"]}>
        <Chip
          background={getBackground(state)}
          border={getBorder(state)}
          size={size}
        >
          <Trans>2x</Trans>
        </Chip>
      </CustomProperties>
    );
  }

  return <CompetenceChip competence={requirement} state={state} size={size} />;
};
